import { isNull, get } from "lodash"
import locales from "./../../../content.json";

import fire from './img/fire.png'
import horns from './img/horns.png'
import thinking from './img/thinking.png'

export const checkIsValidCurrentActivity = data => {
    return validateCurrentStep(get(data, ["motivation", "value"], "")) && !data.motivation.isValid
}

export const validateCurrentStep = value => {
    return !isNull(value)
}

export const staticData = {
    0: {
        value: "look at the plan",
        title: locales[window.userLang].motivation_step_1,
        icon: thinking,
    },
    1: {
        value: "lose some weight",
        title: locales[window.userLang].motivation_step_2,
        icon: horns,
    },
    2: {
        value: "drop the most weight",
        title: locales[window.userLang].motivation_step_3,
        icon: fire,
    },
}